function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import isPlainObject from 'lodash/isPlainObject';
import { ERRORS_KEY } from "./constants";
/** Converts an `errorSchema` into a list of `RJSFValidationErrors`
 *
 * @param errorSchema - The `ErrorSchema` instance to convert
 * @param [fieldPath=[]] - The current field path, defaults to [] if not specified
 * @returns - The list of `RJSFValidationErrors` extracted from the `errorSchema`
 */

export default function toErrorList(errorSchema) {
  var fieldPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!errorSchema) {
    return [];
  }

  var errorList = [];

  if (ERRORS_KEY in errorSchema) {
    errorList = errorList.concat(errorSchema[ERRORS_KEY].map(function (message) {
      var property = ".".concat(fieldPath.join('.'));
      return {
        property: property,
        message: message,
        stack: "".concat(property, " ").concat(message)
      };
    }));
  }

  return Object.keys(errorSchema).reduce(function (acc, key) {
    if (key !== ERRORS_KEY) {
      var childSchema = errorSchema[key];

      if (isPlainObject(childSchema)) {
        acc = acc.concat(toErrorList(childSchema, [].concat(_toConsumableArray(fieldPath), [key])));
      }
    }

    return acc;
  }, errorList);
}